import React from 'react';
import styles from './styles/kpiActionPill.module.scss';

/**
 * Small pill-shaped button rendered inside a `MetricCard` action slot.
 * Currently used by the "View Users" affordance on the Overdue Users
 * tile of the Cashflow Management screen.
 *
 * Pure presentational. Returns `null` when no `onClick` is supplied so
 * it can be passed unconditionally to the card without rendering an
 * empty button.
 */
function KpiActionPill({ label, onClick }) {
    if (!onClick) return null;
    return (
        <button type="button" className={styles.pill} onClick={onClick}>
            {label}
        </button>
    );
}

export default KpiActionPill;
